import { FOLDER_NOT_FOUND_TOAST_TITLE, MODULE_NOT_FOUND_TOAST_TITLE } from '../config/directory-container';
import { isModuleCode } from './mapVisibleTreeToNavigation';

export function containerNotFoundToastTitle(code: string): string {
  return isModuleCode(code) ? MODULE_NOT_FOUND_TOAST_TITLE : FOLDER_NOT_FOUND_TOAST_TITLE;
}
